import { Warehouse } from 'lucide-react';

import type { YardGateDock } from 'contracts/YardGate';
import * as S from '../../styles';

interface PhysicalDockBadgeProps {
  docks: readonly YardGateDock[];
  highlighted: boolean;
}

export const formatPhysicalDockLabel = (
  docks: readonly YardGateDock[]
): string | null => {
  if (docks.length === 0) return null;

  const names = docks.map(({ name }) => name).join(', ');
  return docks.length === 1 ? `Doca física ${names}` : `Docas físicas ${names}`;
};

export const PhysicalDockBadge = ({
  docks,
  highlighted,
}: PhysicalDockBadgeProps) => {
  const label = formatPhysicalDockLabel(docks);

  if (!label) return null;

  return (
    <S.PhysicalDockBadge
      role="img"
      aria-label="Doca física salva"
      title={label}
      $highlighted={highlighted}
      data-highlighted={String(highlighted)}
    >
      <Warehouse aria-hidden="true" size={12} />
    </S.PhysicalDockBadge>
  );
};
